import { useMemo, useState, type FC } from "react";
import ChartSwitcher from "@/components/ChartSwitcher";
import {
  buildPerformanceChartOption,
  PERFORMANCE_CHART_TYPE_OPTIONS,
  type ChartType,
} from "@/pages/CampaignOverviewPage/charts/chartOptions";
import ChartStateBody from "@/pages/CampaignOverviewPage/components/ChartStateBody";
import useDarkMode from "@/hooks/useDarkMode";
import type { PerformanceReportRow } from "@/types/reporting";
import { TEXT } from "@/constants/text";
import styles from "@/pages/CampaignOverviewPage/widgets/PerformanceChart.module.css";

interface PerformanceChartProps {
  error: string | null;
  isLoading: boolean;
  rows: PerformanceReportRow[];
}

const PerformanceChart: FC<PerformanceChartProps> = ({
  rows,
  isLoading,
  error,
}) => {
  const isDark = useDarkMode();
  const [chartType, setChartType] = useState<ChartType>("area");
  const option = useMemo(
    () => buildPerformanceChartOption(rows, chartType, isDark),
    [rows, chartType, isDark]
  );

  return (
    <div className={styles.card}>
      <div className={styles.header}>
        <span className={styles.title}>
          {TEXT.campaignOverview.chart.title}
        </span>
        <ChartSwitcher
          label={TEXT.campaignOverview.switcher.chartType}
          options={PERFORMANCE_CHART_TYPE_OPTIONS}
          value={chartType}
          onChange={setChartType}
        />
      </div>
      <ChartStateBody
        error={error}
        errorMessage={TEXT.campaignOverview.kpi.error}
        isEmpty={rows.length === 0}
        isLoading={isLoading}
        loadingClassName={styles.loading}
        messageClassName={styles.message}
        noDataMessage={TEXT.campaignOverview.kpi.noData}
        option={option}
      />
    </div>
  );
};

export default PerformanceChart;
